module.exports = __webpack_public_path__ + "img/credit-card-bold.e1e08dcc.svg";